import { useAuth } from '@/reducers/user'
import { ROLES } from '@/types/user'
import React from 'react'

export function withAdminPanelGuard<T extends object>(WrappedComponent: React.ComponentType<T>) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const InnerComponent = (props: Omit<T, keyof object>) => {
    const { user } = useAuth()

    if (!user) {
      return null
    }

    if (user?.role.name !== ROLES.ADMIN) {
      return null
    }

    return <WrappedComponent {...props} />
  }

  InnerComponent.displayName = `withAdminPanelGuard(${displayName})`

  return InnerComponent
}
